// extracted by mini-css-extract-plugin
export default {"fieldGroup":"registration-form_fieldGroup__A0tfU","helpText":"registration-form_helpText__Q2H4N"};